import {
  Action,
  getModule,
  Module,
  Mutation,
  VuexModule,
} from 'vuex-module-decorators';
import repositoryFactory from '@/api/factory';
import AuthRepository from '@/api/auth';
import {
  getJwtTokenIfNotExpired,
  removeToken,
  setToken,
} from '@/utils/storage';

// eslint-disable-next-line
import store from '@/store';
import { setAuthToken } from '@/api/repository';

const authRepository = repositoryFactory.get<typeof AuthRepository>('auth');

export interface AuthState {
  token: string | null;
}

@Module({
  name: 'auth',
  namespaced: true,
  store,
  dynamic: true,
})
class AuthModule extends VuexModule {
  token: string | null = null;

  @Mutation
  private SET_TOKEN(token: string) {
    this.token = token;

    setAuthToken(token);
  }

  get isAuthenticated() {
    return Boolean(this.token);
  }

  @Action
  async login(userInfo: { username: string; password: string }) {
    const { username, password } = userInfo;

    const { data } = await authRepository.login(username, password);

    setToken(data.token);

    this.SET_TOKEN(data.token);
  }

  @Action
  logout() {
    removeToken();

    this.SET_TOKEN('');
  }

  @Action
  initialize() {
    const token = getJwtTokenIfNotExpired();

    if (!token) {
      return;
    }

    this.SET_TOKEN(token);
  }
}

const authModule = getModule(AuthModule);
authModule.initialize();

export default authModule;
